import React from 'react';
import './WindowHeader.css';
import closeIcon from '../img/close3.jpg';

interface WindowHeaderProps {
  title: string;
  onClose: () => void;
  onMouseDown: (e: React.MouseEvent) => void;
  onTouchStart?: (e: React.TouchEvent) => void;
}

const WindowHeader: React.FC<WindowHeaderProps> = ({ title, onClose, onMouseDown, onTouchStart }) => {
  return (
    <div className="window-header" onMouseDown={onMouseDown} onTouchStart={onTouchStart}>
      <div className="window-header-lines">
        <div className="gray-line"></div>
        <div className="gray-line"></div>
        <div className="gray-line"></div>
        <div className="gray-line"></div>
        <div className="gray-line"></div>
      </div>
      <div className="window-header-content">
        <div className="window-close-button" onClick={onClose}>
          <img src={closeIcon} alt="Close" />
        </div>
        <div className="window-title">{title}</div>
      </div>
    </div>
  );
};

export default WindowHeader;